/*
 * Copyright (C) 2021 to Present Applause App Quality, Inc. All rights reserved.
 */

import { InjectionToken } from '@angular/core';

export interface AvatarService {
  generateAvatarUrl(userId: number, useStoredUrlIfCurrentUser: boolean): string;
}

export const AVATAR_SERVICE = new InjectionToken<AvatarService>('AvatarService');
